import {SecurityLogTypeType} from "../models/response"

export const getRowClassNameSecurityLog = (type: SecurityLogTypeType) => {
    switch (type) {
        case 'info': return 'table-row-color-lightblue'
        case 'error': return 'table-row-color-red'
        case 'danger': return 'table-row-color-orange'
        case 'success': return 'table-row-color-green'
        case 'default': return ''
        default: return ''
    }
}